import {IColors} from '@/types/theme';

export const isValidColor = (color: unknown): boolean =>
  typeof color === 'string' && /^#(?:[0-9a-fA-F]{3}){1,2}$/i.test(color);

export const parseColorsFromUrl = (
  stringifiedColors?: string,
): Partial<IColors> | null => {
  if (!stringifiedColors) {
    return null;
  }

  try {
    const colors = JSON.parse(stringifiedColors);

    if (!colors || typeof colors !== 'object') {
      return null;
    }

    const allowedColorProperties = [
      'primaryLight',
      'primary',
      'primaryDark',
      'backgroundLight',
      'background',
      'backgroundDark',
      'backdrop',
      'borderColor',
      'invertedBorderColor',
      'textColor',
      'invertedTextColor',
      'active',
      'activeBorder',
      'activeText',
      'favoritesColor',
    ];

    const customColors = allowedColorProperties.reduce<Partial<IColors>>(
      (result, colorProperty) => {
        if (colors[colorProperty] && isValidColor(colors[colorProperty])) {
          // @ts-ignore
          result[colorProperty] = colors[colorProperty];
        }

        return result;
      },
      {},
    );

    if (Object.keys(customColors).length === 0) {
      return null;
    }

    return customColors;
  } catch (error) {
    return null;
  }
};
